import React, {useState, useRef, useEffect, createRef} from 'react'
import '@/assets/css/store.scss';
import SearchImg from '@/assets/img/icon/search.png'
import address from '@/assets/img/icon/address-active.png'
import addressActive from '@/assets/img/icon/address.png'
import BMap from 'BMap';
import BMapLib from 'BMapLib';
import { REQUEST } from "@/api";
import intl from 'react-intl-universal';
import Swiper from "swiper"
import "swiper/css/swiper.css"
let map = null
let markers = []
let markerClusterer = null
const News = () => {
    const [adddressList, setAddressList] = useState([])
    const [myMap, setMap] = useState(null)
    const [selectIndex, setSelectIndex] = useState(9)

    const inputRef = createRef();

    // 初始化地图
    const initData = () => {
        // this.data = this.$t('storeArray')
        // eslint-disable-next-line no-undef
        map = new BMap.Map('container')
        setMap(Object.assign({}, map))
        // eslint-disable-next-line no-undef
        // const geolocation = new BMap.Geolocation()
        // eslint-disable-next-line no-undef
        // const point = new BMap.Point(116.403326, 39.915794)
        // eslint-disable-next-line no-undef
        const point = new BMap.Point(121.481977, 31.233953)
        map.centerAndZoom(point, 12)
        map.enableScrollWheelZoom(true) // 开启鼠标滚轮
        map.setMapStyleV2({
            // 配色
            styleId: 'f4cfbb25394e3f8e653e646c3d129a63'
        })
        // eslint-disable-next-line no-undef
        const scaleCtrl = new BMap.ScaleControl() // 添加比例尺控件
        // eslint-disable-next-line no-undef
        map.addControl(new BMap.MapTypeControl()) // 卫星地图
        map.addControl(scaleCtrl)
        // eslint-disable-next-line no-undef
        const navigationControl = new BMap.NavigationControl({
            // 靠左上角位置
            // eslint-disable-next-line no-undef
            anchor: BMAP_ANCHOR_TOP_LEFT,
            // LARGE类型
            // eslint-disable-next-line no-undef
            type: BMAP_NAVIGATION_CONTROL_LARGE,
            // 启用显示定位
            enableGeolocation: true
        })
        map.addControl(navigationControl)
        // 添加定位控件
        // eslint-disable-next-line no-undef
        const geolocationControl = new BMap.GeolocationControl()
        geolocationControl.addEventListener('locationSuccess', function(e) {
            // 定位成功事件
            let address = ''
            address += e.addressComponent.province
            address += e.addressComponent.city
            address += e.addressComponent.district
            address += e.addressComponent.street
            address += e.addressComponent.streetNumber
            console.log(address)
            // alert('当前定位地址为：' + address)
        })
        geolocationControl.addEventListener('locationError', function(e) {
            // 定位失败事件
            alert(e.message)
        })
        map.addControl(geolocationControl)
    }
    const handleMarkers = (myarkers) => {
        markers = myarkers
        // eslint-disable-next-line no-undef,no-new
        markerClusterer = new BMapLib.MarkerClusterer(map, { markers })
        markers.forEach((item) => {
            addEvent(item)
        })
    }
    const openInfo =(content) => {
        const opts = {
            width: 160, // 信息窗口宽度
            height: 60, // 信息窗口高度
            title: content.name.storeName, // 信息窗口标题
            enableMessage: true // 设置允许信息窗发送短息
        }
        // eslint-disable-next-line no-undef
        const point = new BMap.Point(content.point.lng, content.point.lat)
        // eslint-disable-next-line no-undef
        const infoWindow = new BMap.InfoWindow(
            '' + content.name.storeAddress,
            opts
        ) // 创建信息窗口对象
        map.openInfoWindow(infoWindow, point) // 开启信息窗口
    }
    const addMarker = (item, point) => {
        map.clearOverlays()
        markerClusterer.clearMarkers(markers)
        // eslint-disable-next-line no-undef
        const marker = new BMap.Marker(point)
        marker.name = item
        map.addOverlay(marker)
        // eslint-disable-next-line no-undef
        marker.setAnimation(BMAP_ANIMATION_BOUNCE)
        addEvent(marker)
    }
    const addEvent= (item) => {
        item.addEventListener('click', function() {
            openInfo(item)
        })
    }
    const addMapMakers = (list = [], type = 'init') => {
        map.clearOverlays()
        const markers = []
        // const self = this
        // eslint-disable-next-line no-unused-vars
        const xSpan = []
        // eslint-disable-next-line no-undef
        // const myGeo = new BMap.Geocoder()
        let flag = false
        list.forEach((val) => {
            const lng = val.coordinate.split(',')[0]
            const tng = val.coordinate.split(',')[1]
            // 将地址解析结果显示在地图上,并调整地图视野
            if (type !== 'init' && !flag) {
                // eslint-disable-next-line no-undef
                const _point = new BMap.Point(lng, tng)
                flag = true
                map.centerAndZoom(_point, 12)
            }
            // eslint-disable-next-line no-undef
            const point = new BMap.Point(lng, tng)
            // eslint-disable-next-line no-undef
            const pts = new BMap.Marker(point)
            // pts.setAnimation(BMAP_ANIMATION_BOUNCE)
            pts.name = val
            markers.push(pts)
            if (markers.length === list.length) {
                handleMarkers(markers)
            }
        })
    }
    const changeAddress = (item, index) => {
        setSelectIndex(index)
        // eslint-disable-next-line no-undef
        const pointArr = item.coordinate.split(',')
        // eslint-disable-next-line no-undef
        const point = new BMap.Point(pointArr[0], pointArr[1])
        map.centerAndZoom(point, 18)
        addMarker(item, point)
    }
// 搜索跳转页面
    const handleSubmit = (e) => {
        if (!inputRef.current.value) return;
        searchAddressList(inputRef.current.value)
    }

    const searchAddressList = (name) => {
        const data = {
            type: intl.getInitOptions().currentLocale === 'zh-CN' ? '1' : '2',
            name,
            limit: 400,
            page: 1
        }
        REQUEST('searchAddress', data).then((res) => {
            setAddressList(resetAddress(res.body.list))
            addMapMakers(res.body.list, 'search')
        })
    }
    const fetchGetAddress = () => {
        const data = {
            type: intl.getInitOptions().currentLocale === 'zh-CN' ? '1' : '2'
        }
        REQUEST('address', data).then((res) => {
            setAddressList(resetAddress(res.body))
            addMapMakers(res.body)
        })
    }
    function resetAddress(list) {
        const start = Math.ceil(list.length / 4)
        // eslint-disable-next-line no-const-assign
        const arr = []
        for (let a = 0; a < start; a++) {
            arr[a] = list.slice(4 * a, 4 * (a + 1))
        }
        console.log(arr)
        return arr
    }
    useEffect(() => {
        initData()
        fetchGetAddress()
    }, [])
    useEffect(() => {
        const swiper = new Swiper ('.swiper-container', {
            // slidesPerView: 'auto',
            speed: 600,
            observer: true,
            observeParents: true,
            autoplay: false,
            // autoplay: {
            //     delay: 3000,
            //     stopOnLastSlide: false,
            //     disableOnInteraction: false
            // },
            // autoplay: false,
            on: {
                slideChange(t) {
                    setSelectIndex(9)
                    // this.flag.selectIndex = 9
                }
            }
        })
    }, [])
    return (
        <div className="rl">
            <div className="rl-store rl-container">
                <div className="map-box" id="container">
                </div>
                <div className="store-navs flex-column">
                    <div className="nav-item search flex-between">
                        <div className="left flex-center">Search</div>
                        <div className="right flex-row-start">
                            <div className="icon-img">
                                <img src={SearchImg} alt="" onClick={() => handleSubmit()}/>
                            </div>
                            <div className="input-box">
                                <form onSubmit={() => handleSubmit()}>
                                    <input
                                        ref={inputRef}
                                        type="search"
                                        autoComplete="off"
                                        autoFocus={true}
                                        placeholder={intl.get('address')} />
                                </form>
                            </div>
                        </div>
                    </div>
                    <div className="swiper-container">
                        <div className="swiper-wrapper">
                            {
                                adddressList.map((val, index) => {
                                    return (
                                        <div key={index} className="swiper-slide">
                                            <div className="nav-item nav ">
                                                {
                                                    val.map((va, ind) => {
                                                        return (
                                                            // active
                                                            // addressActive
                                                            <div key={va.id} className={['item ', ind === selectIndex ? ' active' : '']}
                                                                 onClick={() => changeAddress(va, ind)}>
                                                                <div className="icon-img">
                                                                    <img src={ind === selectIndex ? addressActive : address} alt=""/>
                                                                </div>
                                                                <div className="item-text flex-center">{va.storeName}</div>
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </div>
                                        </div>
                                    )
                                })
                            }

                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}
export default News
